import React from 'react';
import styled from 'styled-components';
import {
  Flex,
  Text,
  colors,
} from 'react-orange-ui';

const Card = styled.div`
  width: 100%;
  background-color: ${colors.grey6};
  padding: 1rem;
  margin-top: 0.5rem;
`;

const Wrapper = styled(Flex)`
  margin-bottom: 0.5rem;
`;

const LabelWithHelp = (props) => (
  <Wrapper alignItems="flex-start" flexDirection="column">
    <Text as="label" size="l" bold {...props}>
      {props.children}
    </Text>
    <Card id="helpCard">
      <Text id="helpMessage" tabIndex="0">
        {props.help}
      </Text>
    </Card>
  </Wrapper>
);

export default LabelWithHelp;
